/**
 * 支付的一些路由
 */
const routerExpert = [
  {
    path: '/pay',
    name: 'Pay',
    meta: {
      title: '支付',
      needLogin: true,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-pay/index.vue'),
  },
  {
    path: '/pay-order',
    name: 'PayOrder',
    meta: {
      title: '支付订单',
      needLogin: true,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-pay/PayOrder.vue'),
  },
  {
    path: '/pay-success',
    name: 'PaySuccess',
    meta: {
      title: '支付成功',
      needLogin: true,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-pay/PaySuccess.vue'),
  },
];

export default routerExpert;
